var map = {
	"./borneo.es.json": [
		"../../../../../src/assets/i18n/borneo.es.json",
		"borneo.es.json"
	],
	"./quanthum.es.json": [
		"../../../../../src/assets/i18n/quanthum.es.json",
		"quanthum.es.json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/assets/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/i18n lazy ^\.\/.*\.json$
// module id = ../../../../../src/assets/i18n lazy recursive ^\.\/.*\.json$
// module chunks = main